import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { getCurrentAdStateSelectedComponents, getFonts } from 'Selectors';
import { fetchFontInfo } from 'Actions/fontActions';
import { setSelectBoxOpen } from 'Actions/UIActions';
import { setFontWithDefaultWeight } from 'Actions/settingsActions';
import Select from 'SharedComponents/WveInputs/style';
import WveLinkButton from 'SharedComponents/WveInputs/WveLinkButton/WveLinkButton';

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 10px;
`;

const Button = styled(WveLinkButton)`
  margin-left: 10px;
`;

class WveInputFont extends Component {
  componentDidMount() {
    // WFP.on('font-selected', this.fontSelected); // eslint-disable-line no-undef
    // WFP.on('uploaded', this.fontUploaded); // eslint-disable-line no-undef
  }
  fontUploaded = (data) => {
    const uploadedFonts = data.fonts;
    const { fontSelected } = this; // eslint-disable-line no-shadow
    const { fonts } = this.props;
    const font = fonts.find(f => f.name === uploadedFonts[0].fonts[0].name);
    if (font) {
      fontSelected(font);
    } else {
      fontSelected(uploadedFonts[0].fonts[0]);
    }
  };
  fontSelected = (fontInfo) => {
    const { fetchFontInfo, // eslint-disable-line no-shadow
      fonts,
      setFontWithDefaultWeight } = this.props; // eslint-disable-line no-shadow
    const fontId = (fontInfo.id) ? fontInfo.id : fontInfo;
    if (!fonts.find(f => f.id === fontId)) {
      fetchFontInfo(fontId)
        .then(f => setFontWithDefaultWeight(f.id));
    } else {
      setFontWithDefaultWeight(fontId);
    }
  };
  handleOpen = () => {
    const { setSelectBoxOpen } = this.props; // eslint-disable-line no-shadow
    setSelectBoxOpen(true);
  };
  handleClose = () => {
    const { setSelectBoxOpen } = this.props; // eslint-disable-line no-shadow
    setSelectBoxOpen(false);
  };
  showBrowse = () => {
    WFP.browse(); // eslint-disable-line no-undef
  };
  showUpload = () => {
    WFP.upload(); // eslint-disable-line no-undef
  };
  renderFontOption = font => <option value={font.name}>{font.name}</option>;
  renderFontValue = font => <span style={{ fontFamily: font.name }}>{font.name}</span>;
  render() {
    const { fonts, selectedComponents } = this.props;
    const fontId = selectedComponents.first().settings.get('WFPFontId');
    const font = fonts.find(f => f.id === fontId) || null;
    const selectOptions = fonts.toJS().map(fontOption => ({
      id: fontOption.name,
      name: fontOption.name,
      value: fontOption.name,
      style: { fontFamily: `${fontOption.name}` },
    }));
    return (
      <div
        className="wve-form-item wve-form-item-long"
      >
        <Select
          options={selectOptions}
          onChange={this.fontSelected}
          onValueClick={this.handleValueClick}
          optionRenderer={this.renderFontOption}
          valueRenderer={this.renderFontValue}
          value={font}
          placeholder={'Select a typeface...'}
          clearable={false}
          backspaceRemoves={false}
          isSearchable
          onOpen={this.handleOpen}
          onClose={this.handleClose}
        />
      </div>
    );
  }
}

WveInputFont.propTypes = {
  fonts: PropTypes.instanceOf(List),
  selectedComponents: PropTypes.instanceOf(List).isRequired,
  setSelectBoxOpen: PropTypes.func,
  setFontWithDefaultWeight: PropTypes.func,
  fetchFontInfo: PropTypes.func,
};

WveInputFont.defaultProps = {
  fetchFontInfo: () => {},
  setFontWithDefaultWeight: () => {},
  setSelectBoxOpen: () => {},
  fonts: new List(),
};

const mapStateToProps = state => ({
  fonts: getFonts(state),
  selectedComponents: getCurrentAdStateSelectedComponents(state),
});

const mapDispatchToProps = (dispatch) => {
  return {
    setSelectBoxOpen: (open) => {
      dispatch(setSelectBoxOpen(open));
    },
    fetchFontInfo: fontId => dispatch(fetchFontInfo(fontId)),
    setFontWithDefaultWeight: fontId => dispatch(setFontWithDefaultWeight(fontId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WveInputFont);



// WEBPACK FOOTER //
// ./app/javascript/packs/Shared/components/WveInputs/WveInputFont/WveInputFont.jsx